import { __decorate, __metadata } from "tslib";
import { ApiProperty } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import { CartExposeGroup } from '../../cart/interface';
import { OrderExposeGroup } from '../interface';
export class FixtureOrderElementSlotDto {
}
__decorate([
    ApiProperty({
        type: () => String,
        description: 'Real pos guid of the slot (uid field in square catalog slot).',
        example: 'db152d9e-4ed8-43f8-a1ca-8734acf18bf9',
    }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ],
    }),
    __metadata("design:type", String)
], FixtureOrderElementSlotDto.prototype, "posGuid", void 0);
__decorate([
    ApiProperty({ type: () => String, description: 'Ref to the parent order combo store item property uid.', example: '9fdbdd42-45a6-4614-8b04-c2b2fc125b28' }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ],
    }),
    __metadata("design:type", String)
], FixtureOrderElementSlotDto.prototype, "uid", void 0);
__decorate([
    ApiProperty({ type: () => Number, description: 'Slot quantity', example: 1 }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ],
    }),
    __metadata("design:type", Number)
], FixtureOrderElementSlotDto.prototype, "quantity", void 0);
//# sourceMappingURL=FixtureOrderElementSlotDto.js.map